<template>
  <v-container fill-height 
  :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}">
      <v-card width="500"  max-width="500" class="mx-auto mb-6 pa-4" :elevation="2" style="border-radius:30px;box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-card-title class="justify-center font-weight-bold text-sm-h5">{{
          this.lg_joinmeetbtid.title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_joinmeetbtid.subtitle1}}
        </v-col>
        </v-row>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-form @submit.prevent="onSubmit" v-model="valid" ref="form" >
            <!-- Username field -->
              <v-row class="mt-8" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="10" lg="10" md="10" sm="12" xs="12">
            <v-text-field
              dense
              outlined
              :label="this.lg_joinmeetbtid.formplaceholder"
              :placeholder="this.lg_joinmeetbtid.formplaceholder"
              v-model="form.meetId"
              required
              :rules="emailRules"
              prepend-inner-icon="mdi-message-video"
               @keypress="isNumber($event)"
            ></v-text-field>
            </v-col>
                </v-row>
        

           <v-row class="mt-4" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
                outlined
              >
              {{ this.lg_joinmeetbtid.buttonjoin }}
              </v-btn>
              </v-col>
              </v-row>

              <v-row>
           <v-col justify="center" align="center" cols="12">
        <v-icon color="green">mdi-checkbox-marked-circle</v-icon> {{ this.lg_joinmeetbtid.subtitle2 }}
        </v-col>
        </v-row>
               
              <v-divider class="ma-2"></v-divider>

               <v-row>
           <v-col justify="center" align="center" cols="12">
         {{ this.lg_joinmeetbtid.subtitle3 }}
        </v-col>
        </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import { getByMeetNameOnly } from "@/services/api_meetroom";
import api from "@/services/api";
import {lg_joinmeetbtid} from './language/lg_header_joinmeetbyid.js'
import { feature } from "../services/constants.js";

export default {
  data: () => ({
    form: {
      meetId: undefined,
    },
    emailRules: [],
     isRequired: true,
  }),
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async onSubmit() {
        if (this.$refs.form.validate()) {
      try {
        const { meetId } = this.form;
        const res = await api.getByMeetNameOnlydyte(meetId.trim());
        const {
          data: { meet_appid, meet_sta },
        } = res;
        if (meet_sta !== "Y") {
          throw new Error("The meeting was finished");
        }
        // const url = `/meet/${meetId.trim()}/meeting`;
        const url = `/meet/${meetId.trim()}`;

        // this.resultJson = await api.getAllAppId();
        // this.appId = this.resultJson.data[0].app_id_name;

        this.$router.push(url);
      } catch (error) {
        if (error.response?.status === 404) {
          this.$swal.fire("ผิดพลาด", "Meeting ID ไม่ถูกต้อง", "error");
        } else {
          this.$swal.fire("ผิดพลาด", error?.message, "error");
        }
      }
    }

    },
    
  },
 watch: {
    isRequired(val) {
      if (val) {
        this.emailRules = [v => !!v || `${this.lg_joinmeetbtid.put_required}`];
      } else {
        this.emailRules = [];
      }
    }
  },
   computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
      widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "350";
        case "sm":
          return "450";
        case "md":
          return "450";
        case "lg":
          return "500";
        case "xl":
          return "500";
      }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "40%";
        case "sm":
          return "25%";
        case "md":
          return "25%";
        case "lg":
          return "25%";
        case "xl":
          return "20%";
      }
    },
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;
      this.$store.state.meetSta = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_joinmeetbtid = lg_joinmeetbtid.lg_joinmeetbtid_th
        : this.lg_joinmeetbtid = lg_joinmeetbtid.lg_joinmeetbtid_en;


        // console.log("lg_joinmeetbtid: " + JSON.stringify(this.lg_joinmeetbtid));
        
    }, 
    async mounted(){
      this.$store.state.loadFooter = true;
      this.emailRules = this.isRequired ?[(v) => !!v || `${this.lg_joinmeetbtid.put_required}`,]: [];
    }
};
</script>

<style scoped>
.textinform{
  width:75%;
}
@media (max-width: 599px) {
  .joinmeeting-container {
    margin-top:-150px;
  }
  .v-main {
    margin-top:-50px;
    height: 110% !important;
  }
}
@media (max-width: 959px) {
  .joinmeeting-container {
    margin-top:-180px !important;
  }
}

@media (min-width: 1260px) {
  .joinmeeting-container {
    margin-top: 5rem;
  }
  
}

/* .v-main {
    max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
} */
.joinmeeting-container {
    margin-top: -10px;
  }
</style>
